'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snippet = exports.conversation = exports.smartList = exports.salesTeams = exports.salesUser = exports.meetingsLink = exports.message = undefined;

var _normalizr = require('normalizr');

var message = new _normalizr.Schema('messages');
var meetingsLink = new _normalizr.Schema('meetingsLinks');
var salesUser = new _normalizr.Schema('salesUsers');
var salesTeams = new _normalizr.Schema('salesTeams');
var smartList = new _normalizr.Schema('smartLists', { idAttribute: 'listId' });
var visitor = new _normalizr.Schema('visitors', { idAttribute: 'vid' });
var snippet = new _normalizr.Schema('snippets', { idAttribute: 'id' });

var conversation = new _normalizr.Schema('conversations', { idAttribute: 'channel' });

conversation.define({
  visitor: visitor
});

exports.message = message;
exports.meetingsLink = meetingsLink;
exports.salesUser = salesUser;
exports.salesTeams = salesTeams;
exports.smartList = smartList;
exports.conversation = conversation;
exports.snippet = snippet;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/data/Schemas.js
// module id = 154
// module chunks = 0 1